/**
 * 本地时间格式化为 YYYY-MM-DD HH:mm:ss，月日时分秒均两位补零。
 * 空值或无法解析的输入返回 '-'。
 * @param {string|number|Date|null|undefined} value
 * @returns {string}
 */
export function formatDateTime (value) {
  if (value === null || value === undefined || value === '') return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

/**
 * 本地时间格式化为 YYYY-MM-DD，月日均两位补零。
 * 空值或无法解析的输入返回 '-'。
 * @param {string|number|Date|null|undefined} value
 * @returns {string}
 */
export function formatDate (value) {
  if (value === null || value === undefined || value === '') return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
